import React, { Component } from "react"
import { Card, CardBody, CardTitle, Badge, Button, Container, Row, Col, Alert } from "reactstrap"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import logo from "../../assets/images/site-logo.png"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withTranslation } from "react-i18next"
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import {
  Label,
  Input,
  InputGroup,
  FormGroup,
  Nav,
  NavItem
} from "reactstrap";
class SurveyForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectData: '',
      formVisible: true,
      isLoading: true
    }
  }

   componentDidMount() {
    const { match: { params } } = this.props;
    const { contactId } = params;
   axios
      .get(`https://rscoreapi.azurewebsites.net/api/ContactExt/idwithagent/${contactId}`
      )
      .then((res) => {
        this.setState({ contactData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }

  handleSubmit = (values, { setSubmitting }) => {
    const updateFeature = {
      contactId: values.contactId,
      contactGuid: values.contactGuid,
      howSatisfied: values.q1,
      mostLiked: values.q2,
      whatNeedToImprove: values.q3,
      workWithUsAgain: values.q4,
      canConnectForFeedback: values.q5,
      addedOn: new Date().toISOString(),
    
    };

    toast.loading("Please wait...");
    axios.post('https://rscoreapi.azurewebsites.net/api/ContactSurvey', updateFeature, {
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': str
      }
    })
      .then(response => {
        toast.dismiss();

        if (response.data.success) {
          toast.success("Survey Submitted Successfully");
          this.setState({
            formVisible: false,
            thankYouMessage: ``,
          });
        } else {
          response.data.validationErrors.forEach(error => {
            toast.error(error);
          });
        }
        // Handle success
      })
      .catch(error => {
        console.error(error);
        // Handle error
      });
  }
  formatPhoneNumber(phone) {
    if (!phone) return '';
    const cleaned = ('' + phone).replace(/\D/g, '');
    const lastTen = cleaned.slice(-10);
    const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  }
  render() {
    const { formVisible, contactData, thankYouMessage, isLoading } = this.state;

    return (
      <React.Fragment>
       
        <MetaTags>
          <title>Survey | Realty Space</title>
        </MetaTags>
        <ToastContainer autoClose={2000} />
    
          <div className="headrtop">
              <div className="toppart">
                <Row>
                  <Col sm="3">
                    <div className="d-flex flex-wrap gap-2">
                      {contactData?.agentInfo?.logoFilePath ? 
                      <img src={contactData?.agentInfo?.logoFilePath} alt="" height="70px" />
                      : <img src={logo} alt="" height="70px" />}
                      
                    </div>
                  </Col>
                  <Col xl="3">


                  </Col>

                  <Col sm="6">
                    <Row>
                      <Col sm="4">
                        <h4 className="agentInfo"><strong>Agent</strong><br />
                          <span>{contactData?.agentInfo?.firstName+" "+contactData?.agentInfo?.lastName	}</span>
                        </h4>
                      </Col>
                      <Col sm="4">
                        <h4 className="agentInfo"><strong>Phone</strong><br />
                          <span>{contactData?.agentInfo?.agentContact?.cContact?.phone }</span>
                        </h4>
                      </Col>
                      <Col sm="4">
                        <h4 className="agentInfo"><strong>Email</strong><br />
                          <span>{contactData?.agentInfo?.primaryEmail}</span>
                        </h4>
                      </Col>
                    </Row>


                  </Col>
                </Row>

              </div>

            </div>
            <div className="page-content" style={{ paddingTop: 40 }}>

              <Container fluid>
               
                <Row>
                  <Col xl="3"></Col>
                  <Col xl="6">
                    {formVisible ? (
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          contactId: contactData?.id || '',
                          contactGuid:this.props.match.params.contactId,
                          q1: '',
                          q2: '',
                          q3: '', 
                          q4: '',
                          q5: '',
                        }}
                        validationSchema={Yup.object().shape({
                          q1: Yup.string().required("This is Required"),
                          q4: Yup.string().required("This is Required"),
                          q5: Yup.string().required("This is Required")
                        })}

                        onSubmit={this.handleSubmit}


                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Card className="newCard">
                              <CardBody>
                                <CardTitle className="mb-4">
                                  <h2 style={{fontWeight:'bold', fontFamily:'Arial Black'}}>We`d Love Your  Feedback</h2>
                                  <p style={{fontWeight:'normal'}}>Please take a moment to tell us about with agentName. Your feedbacks hepls us serve you and others better.</p>
                                </CardTitle>
                                <Row>
                                  <Col sm="12">
                                     <FormGroup className="mb-3">
                                      <Label htmlFor="q1">
                                        {this.props.t("Overall, how statified were you?*")}
                                      </Label>
                                      <Field
                                        name="q1"
                                        as="Select"
                                        className={
                                          "form-control" +
                                          (errors.q1 && touched.q1
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="q1"
                                      >
                                        <option value="">Select</option>
                                        <option value="Extremely satisfied">Extremely satisfied</option>
                                        <option value="Satisified">Satisified</option>
                                        <option value="Neutral">Neutral</option>
                                        <option value="Dissatisfied">Dissatisfied</option>
                                        <option value="Very Dissatisfied">Very Dissatisfied</option>
                                        </Field>
                                      <ErrorMessage
                                        name="q1"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col sm="12">
                                      <FormGroup className="mb-3">
                                      <Label htmlFor="q2">
                                        {this.props.t("What did you like most about the experience?")}
                                      </Label>
                                      <Field
                                        name="q2"
                                        as="textarea"
                                        className={
                                          "form-control" +
                                          (errors.q2 && touched.q2
                                            ? " is-invalid"
                                            : "")
                                        }
                                        style={{ minHeight: '100px' }}
                                        id="q2"
                                        //placeholder="Enter any additional notes here"
                                      />
                                      <ErrorMessage
                                        name="q2"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                   <Col sm="12">
                                      <FormGroup className="mb-3">
                                      <Label htmlFor="q3">
                                        {this.props.t("What could we improve?")}
                                      </Label>
                                      <Field
                                        name="q3"
                                        as="textarea"
                                        className={
                                          "form-control" +
                                          (errors.q3 && touched.q3
                                            ? " is-invalid"
                                            : "")
                                        }
                                        style={{ minHeight: '100px' }}
                                        id="q3"
                                        //placeholder="Enter any additional notes here"
                                      />
                                      <ErrorMessage
                                        name="q3"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                 <Col sm="12">
                                     <FormGroup className="mb-3">
                                      <Label htmlFor="q4">
                                        {this.props.t("Would you work with us again?*")}
                                      </Label>
                                      <Field
                                        name="q4"
                                        as="Select"
                                        className={
                                          "form-control" +
                                          (errors.q4 && touched.q4
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="q4"
                                      >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="Maybe">Maybe</option>
                                        <option value="No">No</option>
                                       
                                        </Field>
                                      <ErrorMessage
                                        name="q4"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                   <Col sm="12">
                                     <FormGroup className="mb-3">
                                      <Label htmlFor="q5">
                                        {this.props.t("Can we contact you about your feedback*")}
                                      </Label>
                                      <Field
                                        name="q5"
                                        as="Select"
                                        className={
                                          "form-control" +
                                          (errors.q5 && touched.q5
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="q5"
                                      >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        
                                        <option value="No">No</option>
                                       
                                        </Field>
                                      <ErrorMessage
                                        name="q5"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
       
                                        <Col sm="12">
                                            <h6>Your responses are confidential and will be used only to improve our service.</h6>
                                        </Col>
                                  <Col sm="12">
                                    <button type="submit" className="btn btn-add w-md  mt-27">Submit Feeback</button>
                                  </Col>

                                </Row>

                              </CardBody>
                            </Card>

                          </Form>
                        )}
                      </Formik>
                    ) : (
                      <div className="text-center">
                        <h4 className="text-danger">Thanks for Your Feedback!</h4>

                        <h5>We really appreciate you taking the time to share your thoughts.
 Your feedback helps us grow and serve our clients even better. <br/>

If you ever need anything or have more to share, we’re always here.

</h5>
                       
                      </div>
                    )}
                  </Col>

                </Row>

              </Container>
            </div>
         
       
      </React.Fragment>
    )
  }
}
SurveyForm.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
 


}

const mapStateToProps = ({ Project }) => (
  {
    

  })
const mapDispatchToProps = dispatch => ({
 


});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SurveyForm));


